import React, { Fragment } from "react";
import { createTemplateContents } from "./Templates.helpers";
import Template from "./Template";
import { Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const Templates = () => {
    const language = useSelector((state) => state.languagesState.languages);

    const templates = createTemplateContents(language);
    return (
        <Fragment>
            <Typography fontSize={"24px"} fontWeight={700} marginBottom={"20px"}>
                Templates
            </Typography>
            <Grid container spacing={2}>
                {templates.map((template) => (
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4,
                        }}
                    >
                        <Template {...template} />
                    </Grid>
                ))}
            </Grid>
        </Fragment>
    );
};

export default Templates;
